export default __webpack_public_path__ + "static/media/refresh_icon.adae6eea.png";